import Vue from 'vue'
import { accountAsterisk, formDate } from '@/utils'

//日期格式化 'yyyy-MM-dd'
Vue.filter('date', function(value) {
  return Vue.filter('datetime')(value, 'yyyy-MM-dd')
})

// 日期格式化
Vue.filter('datetime', function(value, format = 'yyyy-MM-dd hh:mm:ss') {
  if (typeof value === 'number' || /^\d+$/.test(value)) {
    // 时间戳
    return formDate(new Date(+value), format)
  } else if (value instanceof Date) {
    // 日期
    return formDate(value, format)
  } else if (typeof value === 'string' && value.length === 19) {
    // yyyy-MM-dd hh:mm:ss
    value = value.replace(/-/g, '/')
    return value.slice(0, 16)
  }

  // 未能处理的时间格式
  return ''
})

// 日期格式化：不含秒的时间格式 'yyyy-MM-dd hh:mm'
Vue.filter('dateWithoutSecond', function(value) {
  // yyyy-MM-dd hh:mm:ss
  if (typeof value === 'string' && value.length === 19) {
    // yyyy-MM-dd hh:mm:ss
    return value.slice(0, 16)
  }

  // 未能处理的时间格式
  return Vue.filter('datetime', 'yyyy-MM-dd hh:mm')
})

// 文件大小
Vue.filter('fileSize', val => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  let i = sizes.length - 1

  if (!val || val == 0) return 0

  while (i > -1) {
    let min = Math.pow(1024, i)
    if (val >= min) {
      let suffix = sizes[i]
      let value = val / min

      // MB 以后两位精确到两位
      value = value.toFixed(i > 1 ? 2 : 0)
      return parseFloat(value) + suffix
    }
    i--
  }
})

// 空字段填充
Vue.filter('empty', val => {
  if (val || val === 0) {
    return val
  }

  return Vue.prototype.$config.empty
})

/**
 * 截取文件名字
 * @param value 文件名
 * @param length 截取长度
 * @returns {*}
 */
Vue.filter('fileName', (value, length) => {
  if (value.lastIndexOf('.') >= length) {
    return value.substr(0, length) + value.substr(value.lastIndexOf('.'))
  } else {
    return value
  }
})

Vue.filter('formatNumber', value => {
  if (value) {
    return (value + '').replace(/[0-9]+?(?=(?:([0-9]{3}))+$)/g, function(a) {
      return a + ','
    })
  } else {
    return 0
  }
})

//认证状态
Vue.filter('authenticateStatusName', function(value) {
  if ([1, 2, 3, 6].includes(value)) {
    return '审核中'
  } else if (value === 4) {
    return '已认证'
  } else if (value === 5) {
    return '审核不通过'
  } else if (value === 0) {
    return '未认证'
  }
})

/**
 * 账号加星号
 */
Vue.filter('accountAsterisk', function(value) {
  return accountAsterisk(value)
})
